import React from "react";
import PricingInfo from "./PricingInfo";
import Testimonial from "./Testimonial";

const Pricing = () => {
  return (
    <div>
      <PricingInfo />
      <Testimonial />
    </div>
  );
};

export default Pricing;
